// eslint-disable-next-line import/prefer-default-export
export const calculateTotalAcres = () => {
  return 199.55;
};

export const unmaskPriceYield = amount => {
  const amountValidated = typeof amount === 'string' ? amount : '';
  return Number.isNaN(Number(amountValidated))
    ? Number.parseFloat(amountValidated.replace(/[$,]/g, ''))
    : Number.parseFloat(amountValidated);
};
